// extracted by mini-css-extract-plugin
export var codeBlockStyle = "CodeBlock-module--codeBlockStyle--ad8a8";
export var liveCodeEditorStyle = "CodeBlock-module--liveCodeEditorStyle--3a774";
export var toolbarStyle = "CodeBlock-module--toolbarStyle--e22cd";
export var whiteBackgroundStyle = "CodeBlock-module--whiteBackgroundStyle--011e0";